<template>
    <div class="l-default">
        <div class="l-default__header">
            <y-header />
        </div>
        <slot />
        <y-loading
            :active="$wait.is('loading-page')"
            :type="$configs.project.loadingMode"
            :color="$configs.project.loadingColor"
            size="60"
            height="100vh"
        />

        <y-footer newsletter />
    </div>
</template>

<script>
    import {
        YHeader,
        YFooter,
    } from '@components';

    export default {
        name: 'DefaultLayout',

        components: {
            YHeader,
            YFooter,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
